import type { QueryClient, QueryKey } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import type { DocumentListResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export type DocumentListSnapshot = [
	QueryKey,
	DocumentListResponseDTO | undefined,
][];

export const updateDocumentLists = async (
	queryClient: QueryClient,
	updater: (list: DocumentListResponseDTO) => DocumentListResponseDTO,
): Promise<DocumentListSnapshot> => {
	await queryClient.cancelQueries({ queryKey: DocumentKeys.allLists });

	const snapshot = queryClient.getQueriesData<DocumentListResponseDTO>({
		queryKey: DocumentKeys.allLists,
	});

	queryClient.setQueriesData<DocumentListResponseDTO>(
		{ queryKey: DocumentKeys.allLists },
		(list) => list && updater(list),
	);

	return snapshot;
};
